module.exports = __webpack_public_path__ + "static/img/index_jbg.6d95948.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_jbg.png
// module id = YZgk
// module chunks = 1